var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ShareSvg from './share.icon.svg';
export const ShareIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: ShareSvg }));
_react_refresh_temp_1 = ShareIcon;
$RefreshReg$(_react_refresh_temp_1, "ShareIcon");
